import * as React from "react"
const SvgCheckMini = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="m6.705 9.6 5.9-5.9a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-6.6 6.6q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.6-2.6a.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275z" />
  </svg>
)
export default SvgCheckMini
